<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/moment.png" /></div>
      <p>Moment</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/moment/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [
        {
          label: '2.30.1',
          linkList: [
            ur + '2.30.1/moment.js',
            ur + '2.30.1/moment.min.js',
            ur + '2.30.1/locale/zh-cn.js',
            ur + '2.30.1/locale/zh-cn.min.js'
          ]
        },
        {
          label: '2.29.4',
          linkList: [
            ur + '2.29.4/moment.js',
            ur + '2.29.4/moment.min.js',
            ur + '2.29.4/locale/zh-cn.js',
            ur + '2.29.4/locale/zh-cn.min.js'
          ]
        }, {
          label: '2.22.1',
          linkList: [
            ur + '2.22.1/moment.js',
            ur + '2.22.1/moment.min.js',
            ur + '2.22.1/locale/zh-cn.js'
          ]
        }, {
          label: '2.22.0',
          linkList: [
            ur + '2.22.0/moment.js',
            ur + '2.22.0/moment.min.js',
            ur + '2.22.0/locale/zh-cn.js'
          ]
        }, {
          label: '2.21.0',
          linkList: [
            ur + '2.21.0/moment.js',
            ur + '2.21.0/moment.min.js',
            ur + '2.21.0/locale/zh-cn.js'
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListMoment.vue